import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

type HideOnRouteProps = Readonly<{
  route: string;
  children: ReactNode;
}>;

export const HideOnRoute = ({ route, children }: HideOnRouteProps) => {
  const location = useLocation();

  const shouldHide = location.pathname.startsWith(`/${route}/`);

  if (shouldHide) return null;

  return <>{children}</>;
};
